/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigResponse } from '../../models/config-response';

export interface GetConfig$Params {
  configId: string;
}

export function getConfig(http: HttpClient, rootUrl: string, params: GetConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigResponse>> {
  const rb = new RequestBuilder(rootUrl, getConfig.PATH, 'get');
  if (params) {
    rb.path('configId', params.configId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfigResponse>;
    })
  );
}

getConfig.PATH = '/config/{configId}';
